// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap&subset=cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLOR VARIABLES */

.cookies-settings-dialog {
  --trimble-blue: #0063a3;
  --trimble-blue-light: #217cbb;
  --trimble-gray: #252a2e;
  --trimble-gray-8: #464b52;
  --trimble-gray-4: #90939f;
  --trimble-gray-0: #e0e1e9;
  --trimble-gray-light: #f1f1f6;
  --modus-modal-border-color: rgba(0, 0, 0, 0.2);
  --modus-btn-outline-secondary-hover-color: #3c444a;
  --modus-btn-outline-secondary-hover-bg: rgba(33, 42, 50, 0.15);
}

/* FONT STYLES */
.cookie-preferences-link {
  cursor: pointer;
  border: hidden !important;
  background: inherit !important;
  background-color: inherit !important;
  color: inherit !important;
  line-height: inherit !important;
  font-size: inherit;
  font-family: inherit;
  margin: inherit !important;
  padding: inherit !important;
  font-weight: inherit !important;
}

.cookies-settings-dialog-content * {
  font-family: "Open Sans", sans-serif;
}

.cookies-settings-dialog .cookies-settings-dialog-content {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 21px;
  color: var(--trimble-gray-8);
}

.cookies-settings-dialog .cookies-settings-dialog-content h2 {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0.15px;
}

.cookies-settings-dialog .cookies-settings-dialog-content h3 {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  line-height: 27px !important;
  letter-spacing: 0.15px !important;
  margin: inherit;
  color: var(--trimble-gray-8);
}

.cookies-settings-dialog .cookies-settings-dialog-content h4 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin: 0;
}

.cookies-settings-dialog .cookies-settings-dialog-content h5 {
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}

.cookies-settings-dialog .cookies-settings-dialog-content a {
  color: var(--trimble-blue);
  text-decoration: none;
  transition: color 150ms ease;
  font-weight: 600;
  font-style: normal;
  color: var(--trimble-blue);
  display: inline;
  line-height: inherit;
  margin: 0;
}

.cookies-settings-dialog .cookies-settings-dialog-content a:hover {
  color: var(--trimble-blue-light);
}

.cookies-settings-dialog .cookies-settings-dialog-content p {
  color: var(--trimble-gray-8);
  font-size: 0.875rem;
}

/* DIALOG STYLES */

.cookies-settings-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #252a2ebf;
  z-index: 9999;
}

.cookies-settings-dialog-overlay.show-background {
  visibility: hidden;
}

.cookies-settings-dialog {
  background-color: var(--trimble-gray-light);
  border: 1px solid var(--modus-modal-border-color);
  border-radius: 0.125rem;
  outline: none;
  overflow: auto;
  padding: 0 1rem;
  max-height: 90%;
  visibility: visible;
  font-size: 0.875rem;
}

.cookies-settings-dialog.banner {
  position: fixed;
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  top: auto;
  width: 100vw;
}

.cookies-settings-dialog.preference-view {
  position: absolute;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  margin-right: -50%;
  padding: 0;
  width: 40%;
  max-width: 800px;
}

/* DIALOG CONTENT STYLES */

.cookies-settings-dialog .cookies-settings-dialog-content>header {
  align-items: center;
  border-bottom: 1px solid var(--trimble-gray-0);
  display: flex;
  height: 64px;
  justify-content: center;
  padding: 0px 1rem;
}

.cookies-settings-dialog.banner .cookies-settings-dialog-content .cookies-dialog-header {
  margin: 20px 0;
  display: block;
  text-align: center;
  justify-content: center;
}

.cookies-actions {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cookies-settings-dialog .cookies-settings-dialog-content button {
  margin: inherit;
  padding: inherit;
}

.cookies-actions button.cookies-button {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  display: inline-flex;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: normal;
  justify-content: center;
  position: relative;
  transition: color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  height: 32px;
}

.cookies-actions button.cookies-button.secondary {
  background-color: var(--modus-btn-outline-secondary-bg, transparent);
  border-color: var(--trimble-gray-8);
  color: var(--trimble-gray-8);
}

.cookies-actions button.cookies-button.secondary:hover:not([disabled]) {
  background-color: var(--modus-btn-outline-secondary-hover-bg);
  border-color: var(--modus-btn-outline-secondary-hover-color);
  color: var(--modus-btn-outline-secondary-hover-color);
}

.cookies-actions button.cookies-button.primary {
  background-color: var(--trimble-blue);
  color: white;
}

.cookies-actions button.cookies-button.primary:hover {
  background-color: var(--trimble-blue-light);
  color: white;
}

/* Banner styles */

.cookies-settings-dialog.banner>.cookies-settings-dialog-content {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  height: 100%;
  display: flex;
  flex-flow: row;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-dialog-header {
  display: flex;
  flex-flow: row-reverse;
  flex: 15%;
  align-items: center;
  flex-basis: auto;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-dialog-header h4 {
  font-size: 20px;
  line-height: 28px;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content {
  margin: 16px;
  flex: 60%;
  align-self: center;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content>p {
  display: inline;
  color: var(--trimble-gray-8);
  font-size: 0.875rem;
  line-height: 21px;
  font-weight: 400;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions {
  flex-flow: row-reverse;
  flex: 25%;
  align-self: center;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions>div {
  width: 50%;
}

.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions>div>button {
  width: 95%;
  margin: 0;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}

/* Preference view */

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>.dialog-body {
  border-top: 1px solid var(--trimble-gray-0);
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>header,
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>section {
  padding: 0 20px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>footer {
  border-top: 1px solid var(--trimble-gray-0);
  padding: 20px 20px;
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-text-content {
  margin: 16px 0;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content button.cookies-button.secondary {
  margin-right: 25px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content button.cookies-button.primary {
  margin-left: 25px;
}


/* Preference view: cookie group styles */

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content hr.cookies-group-separator {
  border: 0;
  border-top: 1px solid var(--trimble-gray-0);
  margin: 0;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group {
  margin: 0px;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group p {
  margin-bottom: 0px;
  margin-top: 1em;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table table {
  padding: 0 0 5px 5px;
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table thead {
  color: #464b52;
  background-color: #f1f1f6;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table tr {
  color: #252a2e;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td,
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table th {
  padding: 0.5em;
  overflow-wrap: break-word;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(1),
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(2) {
  max-width: 120px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-list-provider {
  color: #464b52;
  background-color: #f1f1f6;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  padding: 0.5em;
  align-items: center;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-information {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-group-name {
  display: flex;
  padding: 0;
  cursor: pointer;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name h4 {
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  line-height: 24px;
  color: var(--trimble-blue);
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name:hover h4 {
  color: var(--trimble-blue-light);
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name:hover svg {
  fill: var(--trimble-blue-light);
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed,
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-open {
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed {
  fill: var(--trimble-blue);
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed,
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-open {
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-description {
  margin-left: 34px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table {
  padding-top: 18px;
  margin-left: 28px;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch {
  display: inline-flex;
  flex-direction: row;
  width: 20%;
  justify-content: flex-end;
  align-self: start;
}

/* Slider switches  */
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle {
  position: relative;
  display: inline-flex;
  flex-direction: row;
  width: 30px;
  margin-right: 12px;
  padding: 0;
  align-items: flex-start;
  height: 0.875rem;
}

/* Hide default HTML checkbox */
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  height: 14px;
  inset: 0px;
  background-color: var(--trimble-gray-4);
  border: 2px var(--trimble-gray-4) solid;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 16px;
  box-sizing: content-box;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch>.cookies-toggle>.cookies-toggle-slider:after {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 0px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: all 0.1s ease 0s;
  transition: all 0.1s ease 0s;
  border-radius: 50%;
  box-sizing: initial;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:checked+.cookies-toggle-slider {
  background-color: var(--trimble-blue-light);
  border: 2px var(--trimble-blue-light) solid
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:disabled+.cookies-toggle-slider {
  opacity: 0.3;
  cursor: default;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:hover+.cookies-toggle-slider {
  border: 2px var(--trimble-blue-light) solid
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:checked+.cookies-toggle-slider:after {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
  box-sizing: initial;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle-text {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  line-height: 21px;
  color: var(--trimble-gray);
  ;
}

.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle-text.disabled {
  color: #e2e2e7;
}

.cookies-settings-dialog.preference-view>.scroll-down-icon {
  display: none;
}

/* RESPONSIVITY */

/* Large devices (laptops/desktops, up to 1200px) */
@media only screen and (max-width: 1200px) {
  .cookies-settings-dialog.preference-view {
    width: 50%;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-dialog-header {
    flex-flow: column;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {
    flex-flow: column-reverse;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {
    margin-bottom: 1em;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions>div {
    width: 100%;
  }
}

/* Medium devices (landscape tablets, 992px and down) */
/* Preference view: start displaying scroll down icon if content overflows,  */
@media only screen and (max-width: 992px) {
  .cookies-settings-dialog.preference-view {
    max-height: 70%;
    width: 70%;
  }

  .cookies-settings-dialog.preference-view.with-long-content {
    height: 90%;
    max-height: none;
  }

  .cookies-settings-dialog.preference-view.with-long-content {
    height: 70%;
    max-height: none;
  }

  .cookies-settings-dialog.preference-view>.scroll-down-icon {
    display: inherit;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 15%;
    padding-bottom: 10px;
    z-index: 1;
    background: -webkit-linear-gradient(-90deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);
    background: -moz-linear-gradient(180deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-toggle {
    padding: 0;
    vertical-align: middle;
  }
}


/* Small devices (portrait tablets and large phones, 768px and down) */
/* Banner: cookie information is hidden, content is dislpayed in a column
*/
@media only screen and (max-width: 768px) {
  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div {
    width: 100%;
  }

  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div {
    width: 100%;
  }

  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div>button.cookies-button {
    width: 90%;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content {
    display: block;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content .cookies-general-information {
    display: none;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-dialog-header {
    display: block;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {
    flex-flow: row;
    width: 100%;
    padding-bottom: 2rem;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {
    margin: 0;
  }
}

/* Extra small devices (phones, 600px and down) */
/* Banner: buttons stack */
/* Preference view: grows to fill screen, font size gets smaller, buttons stack */
@media only screen and (max-width: 600px) {
  .cookies-settings-dialog {
    max-height: 80%;
    width: 80%;
  }

  .cookies-settings-dialog.preference-view.with-long-content {
    height: 90%;
    max-height: none;
  }

  .cookies-settings-dialog.preference-view {
    max-height: 90%;
    width: 90%;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-group-name h4 {
    font-size: 1rem;
    font-weight: 700;
    line-height: 24px;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group {
    flex-direction: column;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-information {
    display: block;
    width: 100%;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch {
    margin: 1em 0 0 2.125rem;
    justify-content: flex-start;
    width: 100%;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions {
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
    padding: 0;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions>div {
    width: 100%;
    text-align: center;
    margin: auto;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button {
    width: 100%;
    min-height: 32px;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button.primary {
    margin-left: 0;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button.secondary {
    margin-right: 0;
    margin-top: 16px;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {
    flex-flow: column-reverse;
    width: 100%;
  }

  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {
    margin-bottom: 1em;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table table {
    margin-right: 1em;
  }

  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(1),
  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(2) {
    max-width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/cookies.css"],"names":[],"mappings":"AAEA,oBAAoB;;AAEpB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,8CAA8C;EAC9C,kDAAkD;EAClD,8DAA8D;AAChE;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iJAAiJ;EACjJ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oEAAoE;EACpE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4DAA4D;EAC5D,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,yCAAyC;;AAEzC;EACE,SAAS;EACT,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uCAAuC;EACvC,uCAAuC;EACvC,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;;AAE5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;;AAEjB,mDAAmD;AACnD;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uDAAuD;AACvD,8EAA8E;AAC9E;EACE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,mIAAmI;IACnI,gIAAgI;IAChI,2HAA2H;EAC7H;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;;AAGA,sEAAsE;AACtE;CACC;AACD;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,iDAAiD;AACjD,0BAA0B;AAC1B,iFAAiF;AACjF;EACE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap&subset=cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese');\n\n/* COLOR VARIABLES */\n\n.cookies-settings-dialog {\n  --trimble-blue: #0063a3;\n  --trimble-blue-light: #217cbb;\n  --trimble-gray: #252a2e;\n  --trimble-gray-8: #464b52;\n  --trimble-gray-4: #90939f;\n  --trimble-gray-0: #e0e1e9;\n  --trimble-gray-light: #f1f1f6;\n  --modus-modal-border-color: rgba(0, 0, 0, 0.2);\n  --modus-btn-outline-secondary-hover-color: #3c444a;\n  --modus-btn-outline-secondary-hover-bg: rgba(33, 42, 50, 0.15);\n}\n\n/* FONT STYLES */\n.cookie-preferences-link {\n  cursor: pointer;\n  border: hidden !important;\n  background: inherit !important;\n  background-color: inherit !important;\n  color: inherit !important;\n  line-height: inherit !important;\n  font-size: inherit;\n  font-family: inherit;\n  margin: inherit !important;\n  padding: inherit !important;\n  font-weight: inherit !important;\n}\n\n.cookies-settings-dialog-content * {\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 21px;\n  color: var(--trimble-gray-8);\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content h2 {\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0.15px;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content h3 {\n  font-size: 1.125rem !important;\n  font-weight: 600 !important;\n  line-height: 27px !important;\n  letter-spacing: 0.15px !important;\n  margin: inherit;\n  color: var(--trimble-gray-8);\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  margin: 0;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content h5 {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content a {\n  color: var(--trimble-blue);\n  text-decoration: none;\n  transition: color 150ms ease;\n  font-weight: 600;\n  font-style: normal;\n  color: var(--trimble-blue);\n  display: inline;\n  line-height: inherit;\n  margin: 0;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content a:hover {\n  color: var(--trimble-blue-light);\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content p {\n  color: var(--trimble-gray-8);\n  font-size: 0.875rem;\n}\n\n/* DIALOG STYLES */\n\n.cookies-settings-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #252a2ebf;\n  z-index: 9999;\n}\n\n.cookies-settings-dialog-overlay.show-background {\n  visibility: hidden;\n}\n\n.cookies-settings-dialog {\n  background-color: var(--trimble-gray-light);\n  border: 1px solid var(--modus-modal-border-color);\n  border-radius: 0.125rem;\n  outline: none;\n  overflow: auto;\n  padding: 0 1rem;\n  max-height: 90%;\n  visibility: visible;\n  font-size: 0.875rem;\n}\n\n.cookies-settings-dialog.banner {\n  position: fixed;\n  box-sizing: border-box;\n  bottom: 0;\n  left: 0;\n  top: auto;\n  width: 100vw;\n}\n\n.cookies-settings-dialog.preference-view {\n  position: absolute;\n  display: flex;\n  flex-flow: column;\n  align-items: stretch;\n  top: 50%;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  transform: translate(-50%, -50%);\n  margin-right: -50%;\n  padding: 0;\n  width: 40%;\n  max-width: 800px;\n}\n\n/* DIALOG CONTENT STYLES */\n\n.cookies-settings-dialog .cookies-settings-dialog-content>header {\n  align-items: center;\n  border-bottom: 1px solid var(--trimble-gray-0);\n  display: flex;\n  height: 64px;\n  justify-content: center;\n  padding: 0px 1rem;\n}\n\n.cookies-settings-dialog.banner .cookies-settings-dialog-content .cookies-dialog-header {\n  margin: 20px 0;\n  display: block;\n  text-align: center;\n  justify-content: center;\n}\n\n.cookies-actions {\n  padding: 0 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.cookies-settings-dialog .cookies-settings-dialog-content button {\n  margin: inherit;\n  padding: inherit;\n}\n\n.cookies-actions button.cookies-button {\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 600;\n  font-size: 0.875rem;\n  line-height: normal;\n  justify-content: center;\n  position: relative;\n  transition: color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;\n  height: 32px;\n}\n\n.cookies-actions button.cookies-button.secondary {\n  background-color: var(--modus-btn-outline-secondary-bg, transparent);\n  border-color: var(--trimble-gray-8);\n  color: var(--trimble-gray-8);\n}\n\n.cookies-actions button.cookies-button.secondary:hover:not([disabled]) {\n  background-color: var(--modus-btn-outline-secondary-hover-bg);\n  border-color: var(--modus-btn-outline-secondary-hover-color);\n  color: var(--modus-btn-outline-secondary-hover-color);\n}\n\n.cookies-actions button.cookies-button.primary {\n  background-color: var(--trimble-blue);\n  color: white;\n}\n\n.cookies-actions button.cookies-button.primary:hover {\n  background-color: var(--trimble-blue-light);\n  color: white;\n}\n\n/* Banner styles */\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0;\n  height: 100%;\n  display: flex;\n  flex-flow: row;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-dialog-header {\n  display: flex;\n  flex-flow: row-reverse;\n  flex: 15%;\n  align-items: center;\n  flex-basis: auto;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-dialog-header h4 {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content {\n  margin: 16px;\n  flex: 60%;\n  align-self: center;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content>p {\n  display: inline;\n  color: var(--trimble-gray-8);\n  font-size: 0.875rem;\n  line-height: 21px;\n  font-weight: 400;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions {\n  flex-flow: row-reverse;\n  flex: 25%;\n  align-self: center;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions>div {\n  width: 50%;\n}\n\n.cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-actions>div>button {\n  width: 95%;\n  margin: 0;\n  padding-left: 0.875rem;\n  padding-right: 0.875rem;\n}\n\n/* Preference view */\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>.dialog-body {\n  border-top: 1px solid var(--trimble-gray-0);\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>header,\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>section {\n  padding: 0 20px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content>footer {\n  border-top: 1px solid var(--trimble-gray-0);\n  padding: 20px 20px;\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-text-content {\n  margin: 16px 0;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content button.cookies-button.secondary {\n  margin-right: 25px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content button.cookies-button.primary {\n  margin-left: 25px;\n}\n\n\n/* Preference view: cookie group styles */\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content hr.cookies-group-separator {\n  border: 0;\n  border-top: 1px solid var(--trimble-gray-0);\n  margin: 0;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group {\n  margin: 0px;\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group p {\n  margin-bottom: 0px;\n  margin-top: 1em;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table table {\n  padding: 0 0 5px 5px;\n  border-collapse: separate;\n  text-indent: initial;\n  border-spacing: 2px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table thead {\n  color: #464b52;\n  background-color: #f1f1f6;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n  display: table-header-group;\n  vertical-align: middle;\n  border-color: inherit;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table tbody {\n  display: table-row-group;\n  vertical-align: middle;\n  border-color: inherit;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table tr {\n  color: #252a2e;\n  background-color: #ffffff;\n  font-size: 14px;\n  font-weight: 400;\n  display: table-row;\n  vertical-align: inherit;\n  border-color: inherit;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td,\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table th {\n  padding: 0.5em;\n  overflow-wrap: break-word;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(1),\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(2) {\n  max-width: 120px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-list-provider {\n  color: #464b52;\n  background-color: #f1f1f6;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  flex-direction: row;\n  padding: 0.5em;\n  align-items: center;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-information {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-group-name {\n  display: flex;\n  padding: 0;\n  cursor: pointer;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name h4 {\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: none;\n  line-height: 24px;\n  color: var(--trimble-blue);\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name:hover h4 {\n  color: var(--trimble-blue-light);\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name:hover svg {\n  fill: var(--trimble-blue-light);\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed,\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-open {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 16px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed {\n  fill: var(--trimble-blue);\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-closed,\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-name>.arrow-open {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 16px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-group-description {\n  margin-left: 34px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table {\n  padding-top: 18px;\n  margin-left: 28px;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch {\n  display: inline-flex;\n  flex-direction: row;\n  width: 20%;\n  justify-content: flex-end;\n  align-self: start;\n}\n\n/* Slider switches  */\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle {\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  width: 30px;\n  margin-right: 12px;\n  padding: 0;\n  align-items: flex-start;\n  height: 0.875rem;\n}\n\n/* Hide default HTML checkbox */\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 30px;\n  height: 14px;\n  inset: 0px;\n  background-color: var(--trimble-gray-4);\n  border: 2px var(--trimble-gray-4) solid;\n  -webkit-transition: .4s;\n  transition: .4s;\n  border-radius: 16px;\n  box-sizing: content-box;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch>.cookies-toggle>.cookies-toggle-slider:after {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 0px;\n  bottom: 0px;\n  background-color: white;\n  -webkit-transition: all 0.1s ease 0s;\n  transition: all 0.1s ease 0s;\n  border-radius: 50%;\n  box-sizing: initial;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:checked+.cookies-toggle-slider {\n  background-color: var(--trimble-blue-light);\n  border: 2px var(--trimble-blue-light) solid\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:disabled+.cookies-toggle-slider {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:hover+.cookies-toggle-slider {\n  border: 2px var(--trimble-blue-light) solid\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle>input:checked+.cookies-toggle-slider:after {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n  box-sizing: initial;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle-text {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.875rem;\n  line-height: 21px;\n  color: var(--trimble-gray);\n  ;\n}\n\n.cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-switch>.cookies-toggle-text.disabled {\n  color: #e2e2e7;\n}\n\n.cookies-settings-dialog.preference-view>.scroll-down-icon {\n  display: none;\n}\n\n/* RESPONSIVITY */\n\n/* Large devices (laptops/desktops, up to 1200px) */\n@media only screen and (max-width: 1200px) {\n  .cookies-settings-dialog.preference-view {\n    width: 50%;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-dialog-header {\n    flex-flow: column;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {\n    flex-flow: column-reverse;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {\n    margin-bottom: 1em;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions>div {\n    width: 100%;\n  }\n}\n\n/* Medium devices (landscape tablets, 992px and down) */\n/* Preference view: start displaying scroll down icon if content overflows,  */\n@media only screen and (max-width: 992px) {\n  .cookies-settings-dialog.preference-view {\n    max-height: 70%;\n    width: 70%;\n  }\n\n  .cookies-settings-dialog.preference-view.with-long-content {\n    height: 90%;\n    max-height: none;\n  }\n\n  .cookies-settings-dialog.preference-view.with-long-content {\n    height: 70%;\n    max-height: none;\n  }\n\n  .cookies-settings-dialog.preference-view>.scroll-down-icon {\n    display: inherit;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 15%;\n    padding-bottom: 10px;\n    z-index: 1;\n    background: -webkit-linear-gradient(-90deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);\n    background: -moz-linear-gradient(180deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, rgba(241, 241, 246, 0.8) 20%, var(--trimble-gray-light) 100%);\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-toggle {\n    padding: 0;\n    vertical-align: middle;\n  }\n}\n\n\n/* Small devices (portrait tablets and large phones, 768px and down) */\n/* Banner: cookie information is hidden, content is dislpayed in a column\n*/\n@media only screen and (max-width: 768px) {\n  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div {\n    width: 100%;\n  }\n\n  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div {\n    width: 100%;\n  }\n\n  .cookies-settings-dialog>.cookies-settings-dialog-content>.cookies-actions>div>button.cookies-button {\n    width: 90%;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content {\n    display: block;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content .cookies-text-content .cookies-general-information {\n    display: none;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-dialog-header {\n    display: block;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {\n    flex-flow: row;\n    width: 100%;\n    padding-bottom: 2rem;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {\n    margin: 0;\n  }\n}\n\n/* Extra small devices (phones, 600px and down) */\n/* Banner: buttons stack */\n/* Preference view: grows to fill screen, font size gets smaller, buttons stack */\n@media only screen and (max-width: 600px) {\n  .cookies-settings-dialog {\n    max-height: 80%;\n    width: 80%;\n  }\n\n  .cookies-settings-dialog.preference-view.with-long-content {\n    height: 90%;\n    max-height: none;\n  }\n\n  .cookies-settings-dialog.preference-view {\n    max-height: 90%;\n    width: 90%;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-group-name h4 {\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 24px;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group {\n    flex-direction: column;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preferences-information {\n    display: block;\n    width: 100%;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookie-preferences-switch {\n    margin: 1em 0 0 2.125rem;\n    justify-content: flex-start;\n    width: 100%;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions {\n    flex-direction: column-reverse;\n    justify-content: center;\n    width: 100%;\n    padding: 0;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions>div {\n    width: 100%;\n    text-align: center;\n    margin: auto;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button {\n    width: 100%;\n    min-height: 32px;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button.primary {\n    margin-left: 0;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookies-actions button.cookies-button.secondary {\n    margin-right: 0;\n    margin-top: 16px;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions {\n    flex-flow: column-reverse;\n    width: 100%;\n  }\n\n  .cookies-settings-dialog.banner>.cookies-settings-dialog-content>.cookies-actions .primary-action {\n    margin-bottom: 1em;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group .cookies-table table {\n    margin-right: 1em;\n  }\n\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(1),\n  .cookies-settings-dialog.preference-view>.cookies-settings-dialog-content .cookie-preference-group table td:nth-child(2) {\n    max-width: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
